import React from 'react';
import PropTypes from 'prop-types';

import styles from './PhoneCard.css';
import DeleteIcon from '../icon-trash.svg';
import { PhoneStore } from '../../../stores/PhoneStore';

const IPropTypes = {
  phone: PropTypes.shape({
    number: PropTypes.string,
    id: PropTypes.string,
  }).isRequired,
};

const deletePhone = phone => (
  PhoneStore.deletePhone(phone)
);

const PhoneCard = props => (
  <div className={styles.container}>
    <div className={styles.containerInfo}>
      <input
        className={styles.phone}
        value={props.phone.number}
        type="text"
        name="phone"
        readOnly
      />
    </div>
    <button onClick={() => deletePhone(props.phone)} className={styles.deleteButton}>
      <img
        src={DeleteIcon}
        alt="delete"
      />
    </button>
  </div>
);

PhoneCard.propTypes = IPropTypes;

export { PhoneCard };



// WEBPACK FOOTER //
// ./src/pages/my-account/phone-card/PhoneCard.jsx